import { BillingCardInformation } from 'common/types';

export const getShopPrimaryPaymentMethod = (
	paymentMethods: BillingCardInformation[] | undefined,
): BillingCardInformation | undefined => {
	if (!paymentMethods) return undefined;
	return paymentMethods.find((method) => method.primary === true) ?? paymentMethods[0];
};
